import React, { useState, useEffect, useCallback } from "react";
import TopHeader from "../../../Component/Header/TopHeader";
import { Box, Button, Typography, Divider } from '@mui/material';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import TableRow from "@mui/material/TableRow";
import {
    usePaginationNewsLetterMutation,
    useDeleteNewsLetterMutation,
    usePublishNewsLetterMutation,
} from "../../../app/services/newsLetterService";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import { toast } from "react-toastify";
import LanguageIcon from "@mui/icons-material/Language";
import Tooltip from "@mui/material/Tooltip";
import ReactPaginate from "react-paginate";
import Spinner from "../../../Component/spinner/spinner";
import { selectCurrentScope, } from "../../../app/auth/authSlice";
import { useSelector } from "react-redux"
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


//table heading
function EnhancedTableHead() {
    const headCells = [
        {
            id: "News Heading",
            numeric: false,
            disablePadding: true,
            label: "Newsletter Heading",
        },
        { id: "Email", numeric: true, disablePadding: false, label: "Email" },
        {
            id: "NewsContent Heading",
            numeric: true,
            disablePadding: false,
            label: "News Content Heading",
        },
        { id: "actions", numeric: true, disablePadding: false, label: "Status" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions", width: '250px !important' },
    ];
    return (
        <>
            <TableHead>
                <TableRow className="menus-color">
                    {headCells.map((headCell) => (
                        <TableCell
                            sx={{ textAlign: "center", color: "#ffff", width: headCell?.width ? headCell?.width : "auto" }}
                            key={headCell.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                        >
                            {headCell.label}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        </>
    );
}

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 500,
    minWidth: 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "5px",
    p: 4,
};

const ViewNewsLetter = () => {
    const navigate = useNavigate(); //route
    const [loading, setLoading] = useState(true);
    const [page, setPage] = React.useState(0); //state for set page
    const [getPaginationNewsLetterData] = usePaginationNewsLetterMutation(); //API call of Get all
    const [deleteNewsLetter] = useDeleteNewsLetterMutation(); //API call of delete
    const [publishNewsletter] = usePublishNewsLetterMutation(); //Api call of publish
    const [open, setOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [allNewsLetter, setAllNewsLetter] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const memberScope = useSelector(selectCurrentScope);
    const [searchTerm, setSearchTerm] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [error, setError] = useState("");

    //Modal usage
    const handleOpen = (id) => {
        setOpen(true);
        setSelectedId(id);
    };

    const handleClose = () => setOpen(false);

    //getAllPendingEventList     
    const getAllPagination = useCallback(() => {
        var data = {
            page: page + 1,
            itemsPerPage: itemsPerPage,
        };
        getPaginationNewsLetterData(data).then((res) => {
            if (res.data?.status) {
                setLoading(false);
                setTotalPage(res?.data?.data?.totalCount || 0);
                setAllNewsLetter(res.data?.data?.newsletterDetails || []);
            } else {
                setLoading(false);
            }
        });
    }, [getPaginationNewsLetterData, page, itemsPerPage]);

    //useEffect
    useEffect(() => {
        getAllPagination();
    }, [getAllPagination]);

    const handlePageClick = ({ selected }) => {
        setSearchTerm('')
        setError("");
        setPage(selected);
    };

    //calculate pagecount
    const pageCount = Math.ceil(totalPage / itemsPerPage);


    const handlePageChange = () => {
        const pageNumber = Number(searchTerm);
        if (isNaN(pageNumber) || pageNumber < 0) {
            setError("Page number cannot be less than 1");
        } else if (pageNumber > pageCount) {
            setError("Please enter valid page number");
        } else if (pageNumber === 0) {
            setError("Please enter page number");
        } else {
            setError("");
            setPage(pageNumber - 1);
        }
    };

    //Edit NewsLetter
    const handleEdit = (id) => {
        if (memberScope === 'PORTAL_SUPER_ADMIN') {
            navigate("/admin/addNewsLetter/" + id);
        }
        else {
            navigate("/assistantAdmin/addNewsLetter/" + id);
        }

        // let routePrefix = "";
        // switch (memberScope) {
        //     case "PORTAL_SUPER_ADMIN":
        //         routePrefix = "/admin/addNewsLetter";
        //         break;
        //     case "PORTAL_ADMIN":
        //         routePrefix = "/assistantAdmin/addNewsLetter";
        //         break;

        // }
        // navigate(`${routePrefix}/${id}`);

        // //     if (memberScope === 'PORTAL_SUPER_ADMIN') {
        // //         navigate("/admin/addNewsLetter/" + id);
        // //     }
        // //     else if (memberScope === 'PORTAL_ADMIN') {
        // //         navigate("/assistantAdmin/addNewsLetter/" + id);
        // //     }
        // navigate("/addNewsLetter/" + id);
    };

    //Delete NewsLetter
    const handleDelete = () => {
        const data = { id: selectedId };
        setLoading(true);
        deleteNewsLetter(data).then((res) => {
            if (res.data.status) {
                setLoading(false);
                toast.error("NewsLetter Deleted Successfully");
                handleClose();
                if (allNewsLetter.length <= 1) {
                    setPage(page - 1);
                    getAllPagination();
                } else {
                    getAllPagination();
                }
            } else {
                setLoading(false);
            }
        });
    }

    //publish newsletter
    const publishNewsLetter = (id) => {
        const data = { id: id };
        setLoading(true);
        publishNewsletter(data).then((res) => {
            if (res?.data.data) {
                setLoading(false);
                toast.success("Newsletter Published successfully");
                getAllPagination();
            } else {
                setLoading(false);
            }
        });
    };

    //add newsletter
    const addNewsLetter = () => {
        if (memberScope === "PORTAL_SUPER_ADMIN") {
            navigate("/admin/addNewsLetter/");
        }
        else if (memberScope === "PORTAL_ADMIN") {
            navigate("/assistantAdmin/addNewsLetter/");
        }
    };

    return (
        <div>
            <TopHeader />
            <div className="pt-5">
                <div className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">Newsletter List</h2>
                </div>
            </div>
            <div className='p-md-5 p-3 overallPadding' >
                <Button variant="contained" className="menus-color" style={{ float: "right", marginBottom: "15px" }} onClick={addNewsLetter}>
                    Add Newsletter
                </Button>
                {loading ? (
                    <Spinner />
                ) : (
                    <>
                        <Box>
                            <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
                                <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                                    <EnhancedTableHead />
                                    <TableBody>
                                        {allNewsLetter.length > 0 ? (
                                            allNewsLetter.map((newsLetter, index) => (
                                                <TableRow
                                                    hover
                                                    key={newsLetter._id}
                                                    sx={{
                                                        cursor: "pointer",
                                                        backgroundColor:
                                                            index % 2 === 0 ? "#f0f0f0" : "white",
                                                    }}
                                                >
                                                    <TableCell align="center">
                                                        {newsLetter.heading}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {newsLetter.email}
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ width: "30%" }}>
                                                        {newsLetter.newsContent.map(
                                                            (newsContent, index) => (
                                                                <span key={index}>
                                                                    {newsContent.heading}

                                                                    {index !==
                                                                        newsLetter.newsContent.length - 1 && ","}
                                                                </span>
                                                            )
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {newsLetter.isPublish ? (<span style={{ color: "Green", fontWeight: "600" }}>
                                                            Published
                                                        </span>) : (<span style={{
                                                            color: "#766bcb",
                                                            fontWeight: "600",
                                                        }}>
                                                            Pending
                                                        </span>)}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {!newsLetter.isPublish ?
                                                            (<>
                                                                <Tooltip title="Edit">
                                                                    <IconButton
                                                                        aria-label="delete"
                                                                        onClick={() => handleEdit(newsLetter._id)}
                                                                        disabled={newsLetter.isPublish === true}
                                                                    >
                                                                        <EditIcon
                                                                            style={{
                                                                                color: "green",
                                                                            }}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>) : <></>
                                                        }
                                                        {newsLetter.isPublish === false && (
                                                            <Tooltip title="Publish">
                                                                <IconButton
                                                                    aria-label="EditIcon"
                                                                    onClick={() =>
                                                                        publishNewsLetter(newsLetter._id)
                                                                    }
                                                                >
                                                                    <LanguageIcon style={{ color: "Purple" }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                        <Tooltip title="Delete">
                                                            <span>
                                                                <IconButton
                                                                    aria-label="approve"
                                                                    onClick={() => handleOpen(newsLetter._id)}
                                                                >
                                                                    <DeleteIcon style={{ color: "red" }} />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>

                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center">
                                                    Will Be Added Shortly
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box
                                    sx={style}
                                    className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden"
                                >

                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
                                            Confirmation
                                        </Typography>
                                        <IconButton onClick={handleClose} aria-label="Close">
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                    <Box display="flex" justifyContent="center" width="100%">
                                        <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                                    </Box>
                                    <Typography
                                        id="modal-modal-title"
                                        style={{ color: "#611f1e" }}
                                        variant="h6"
                                        component="h2"
                                        className="content-font"
                                    >
                                        Are You Surely Want to Delete this NewsLetter?
                                    </Typography>
                                    {/* <Box display="flex" justifyContent="center" width="100%">
                      <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                    </Box> */}
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button
                                            variant="outlined"
                                            className="content-font"
                                            style={{

                                                color: "#dc3545",
                                                border: "1px solid #dc3545",
                                                padding: "5px 15px",
                                                borderRadius: "0px",
                                            }}
                                            onClick={handleClose}
                                        >
                                            No
                                        </Button>
                                        <Button
                                            className="mx-2 content-font"
                                            variant="contained"
                                            style={{
                                                backgroundColor: "#2e7d32",
                                                color: "white",
                                                padding: "5px 15px",
                                                borderRadius: "0px",
                                            }}
                                            onClick={() => handleDelete()}
                                        >
                                            Yes
                                        </Button>
                                    </div>
                                </Box>
                            </Modal>
                            <br />
                            {allNewsLetter.length > 0 && (

                                <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                                    <div className="mb-2 mb-md-0">
                                        <div className="d-flex gap-2">
                                            <input
                                                type="number"
                                                min={1}
                                                placeholder="Page no."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="search-input"
                                            />
                                            <div className="goPage cursor-pointer" onClick={handlePageChange}>
                                                <h5 className="p-2 m-0">Go</h5>
                                            </div>
                                        </div>
                                        {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                                    </div>

                                    {/* Pagination in the Center */}
                                    <div className="my-3 my-md-0">
                                        <ReactPaginate
                                            pageCount={pageCount} // Calculate total pages
                                            pageRangeDisplayed={1}
                                            marginPagesDisplayed={1}
                                            onPageChange={handlePageClick}
                                            containerClassName={"pagination"}
                                            activeClassName={"active"}
                                            forcePage={page}
                                            disabledClassName={"disablebtn"}
                                            previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                                            nextLabel={
                                                pageCount > 1 && page + 1 !== pageCount ? "Next" : null
                                            }
                                        />
                                    </div>

                                    <div className="mb-2 mb-md-0">
                                        <FormControl variant="outlined">
                                            <InputLabel></InputLabel>
                                            <Select
                                                className="itemsperpage"
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setItemsPerPage(value);
                                                    setError('')
                                                    setSearchTerm('');
                                                    setPage(0)
                                                }}
                                                MenuProps={{
                                                    MenuListProps: {
                                                        sx: {
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                        },
                                                    },
                                                }}
                                            >
                                                <MenuItem value={10}>10</MenuItem>
                                                <MenuItem value={20}>20</MenuItem>
                                                <MenuItem value={50}>50</MenuItem>
                                                <MenuItem value={100}>100</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            )}
                        </Box>
                    </>
                )}
            </div>
        </div>
    );
};

export default ViewNewsLetter;